import MuiSvgIcon from "@mui/material/SvgIcon";
import React from "react";
export interface SvgIconProps {
    children?: React.ReactNode;
    viewBox?: string;
    role?: "img" | "presentation";
    /** @deprecated */
    fill?: string;
    /** @deprecated */
    width?: string;
    /** @deprecated */
    height?: string;
    /** @deprecated */
    fontSize?: "inherit" | "large" | "medium" | "small";
    /** @deprecated */
    htmlColor?: string;
    /** @deprecated */
    className?: string;
    /** @deprecated */
    style?: React.CSSProperties;
    /** @deprecated */
    color?: "inherit" | "primary" | "secondary" | "action" | "disabled" | "error";
}
export type DeprecatedSvgIconProps = SvgIconProps;
/**
 * @deprecated
 * Deprecated: 14/02/2025
Replacement: Please use Icons from the @octopusdeploy/design-system-icons package instead.
Reason: We are moving away from custom icons and strongly encourage the use of the design system icons.
 */
export function DeprecatedSvgIcon(props: DeprecatedSvgIconProps) {
    return <MuiSvgIcon {...props}>{props.children}</MuiSvgIcon>;
}
